import { createFileRoute, Link } from "@tanstack/react-router";
import { MarketingHeader } from "@/components/marketing/marketing-header";
import { MarketingFooter } from "@/components/marketing/marketing-footer";
import { seoMeta } from "@/lib/seo/head";
import { GLOSSARY } from "@/lib/seo/glossary";
import { JsonLd, breadcrumbSchema } from "@/components/seo/json-ld";
import { SITE } from "@/lib/seo/site";

export const Route = createFileRoute("/glossario/")({
  head: () => seoMeta({
    title: "Glossario AI legale per avvocati",
    description: "Definizioni chiare e citabili dei termini chiave di AI applicata al diritto: RAG, allucinazione, AI Act, zero retention e altri.",
    path: "/glossario",
  }),
  component: GlossarioIndex,
});

function GlossarioIndex() {
  const definedTermSet = {
    "@context": "https://schema.org",
    "@type": "DefinedTermSet",
    name: "Glossario AI legale di LexAIPro",
    url: `${SITE.url}/glossario`,
    hasDefinedTerm: GLOSSARY.map((g) => ({
      "@type": "DefinedTerm",
      name: g.term,
      description: g.short,
      url: `${SITE.url}/glossario/${g.slug}`,
    })),
  };
  return (
    <div className="min-h-screen bg-background">
      <JsonLd data={[breadcrumbSchema([{name:"Home",path:"/"},{name:"Glossario",path:"/glossario"}]), definedTermSet]} />
      <MarketingHeader />
      <main className="pt-32 pb-24">
        <div className="mx-auto max-w-3xl px-4 sm:px-6">
          <p className="mb-3 text-xs font-semibold uppercase tracking-[0.18em] text-accent">Risorse</p>
          <h1 className="font-display text-4xl font-semibold tracking-[-0.035em] text-foreground sm:text-5xl">Glossario AI legale</h1>
          <p className="mt-5 text-lg text-muted-foreground">Le definizioni essenziali dell'intelligenza artificiale applicata al diritto, scritte per essere chiare e citabili.</p>
          <ul className="mt-12 grid gap-4 sm:grid-cols-2">
            {GLOSSARY.map((g) => (
              <li key={g.slug}>
                <Link to="/glossario/$slug" params={{ slug: g.slug }} className="block rounded-xl border border-border bg-card p-5 transition-colors hover:border-accent">
                  <div className="font-display text-base font-semibold text-foreground">{g.term}</div>
                  <p className="mt-1 text-sm text-muted-foreground">{g.short}</p>
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </main>
      <MarketingFooter />
    </div>
  );
}
